import { library, dom, config } from "@fortawesome/fontawesome-svg-core";

import * as solid from "./solid";
import * as regular from "./regular";
import * as light from "./light";
import * as custom from "./custom";

// Do not display missing icon. Throw error instead
config.showMissingIcons = false;

library.add(
    ...Object.values(solid),
    ...Object.values(regular),
    ...Object.values(light),
    ...Object.values(custom)
);

// Kicks off the process of finding <i> tags and replacing with <svg>
dom.watch();
